<div class="tw-flex tw-flex-col tw-font-inter tw-py-6 tw-pb-10 lg:tw-pb-6 tw-gap-4 tw-px-4 lg:tw-px-0 tw-w-full lg:tw-max-w-[850px] xl:tw-max-w-[1200px] tw-mx-auto">
  <div class="tw-pb-2 tw-flex tw-items-center tw-justify-between">
    <div class="tw-flex tw-flex-col tw-justify-between tw-gap-0 lg:tw-gap-1">
      <h1 class="tw-text-gray-700 tw-text-lg lg:tw-text-2xl tw-font-bold tw-font-inter tw-leading-7 lg:tw-leading-[125%]">Self Printing</h1>
      <p class="tw-text-gray-500 tw-text-sm lg:tw-text-base tw-font-normal tw-font-inter tw-leading-7">
        Print tickets, passes, and other event materials at the event.
      </p>
    </div>
    <button
    type="button"
    class="tw-group tw-relative tw-flex  tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-4 tw-py-3 tw-text-left tw-transition-colors hover:tw-border-blue-200 hover:tw-bg-blue-50"
    [title]="selfPrintLink"
    (click)="copyAndOpenSelfPrintLink()"
  >
    <span class="tw-min-w-0 tw-flex-1 tw-truncate tw-text-sm lg:tw-text-base tw-font-medium tw-text-blue-600 tw-font-inter">
      Self printing link
    </span>
    <span class="tw-flex tw-shrink-0 tw-items-center tw-gap-2">
      @if (selfPrintLinkStatus()) {
        <span class="tw-rounded-full tw-bg-green-50 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-green-700">
          {{ selfPrintLinkStatus() }}
        </span>
      }
      <i class="fas fa-external-link-alt tw-text-sm tw-text-gray-400 group-hover:tw-text-blue-600"></i>
    </span>
  </button>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-mx-auto">
    @if (personaSettingsLoading()) {
      <div
        class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-4 tw-flex tw-flex-col tw-gap-4"
        role="status"
        aria-label="Loading persona settings"
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '45%', height: '20px', 'border-radius': '6px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
          animation="pulse"
          class="tw-block"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', height: '14px', 'border-radius': '6px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
          animation="pulse"
          class="tw-block"
        ></ngx-skeleton-loader>
        <div class="tw-flex tw-flex-col tw-gap-3 tw-pt-1">
          @for (_ of [1, 2, 3, 4]; track $index) {
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '100%', height: '56px', 'border-radius': '8px', backgroundColor: '#e5e7eb', color: '#d1d5db', marginBottom: '0' }"
              animation="pulse"
              class="tw-w-full"
            ></ngx-skeleton-loader>
          }
        </div>
      </div>
    } @else {
      <app-self-print-persona-card
        [personas]="personas()"
        (selfPrintToggled)="onPersonaSelfPrintToggled($event)"
        (limitEdited)="onPersonaLimitEdited()"
      ></app-self-print-persona-card>

      <div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-min-h-10 tw-pt-1">
        <span class="tw-flex-1"></span>
        <div class="tw-flex tw-items-center tw-gap-3">
          @if (hasPendingChanges() || isSaving()) {
            <button
              type="button"
              [buttonSpinner]="isSaving()"
              class="tw-inline-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2.5 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-sm tw-font-medium hover:tw-bg-blue-700 tw-transition-colors"
              (click)="savePersonaSettings()"
            >
              Save
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
